import { SelectOption } from 'components/form-inputs/select-option/select-option';
import { map } from 'lodash';
import { translate, translationKeys } from 'logic/translations/translations.service';
import { WeekDay } from './api-models';

export type WeekDaySelectOption = SelectOption<WeekDay, string>;

export const getWeekDaySelectOptions: () => WeekDaySelectOption[] = () =>
  map(WeekDay).map((weekDay) => ({
    value: weekDay,
    label: translate(translationKeys.common.weekDay[weekDay]),
  }));
